<template>
    <div class="content">
      <h1>Phase Shift</h1>
      <p>Placeholder.</p>
    </div>

</template>


